import { StatModule } from "@/core/modules/stat/objects/StatModule";

import EmployeeMonthReportView from "./views/EmployeeMonthReportView.vue";

export const employeeMonthReport: StatModule = new StatModule("employeeRoster", "EmployeeMonthReport", "employeeRoster", EmployeeMonthReportView);
